/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プラン変更承認依頼を承際する際にPOSTするBody
 * @export
 * @interface PostPlanChangeApprovalRequestApproveBody
 */
export interface PostPlanChangeApprovalRequestApproveBody {
    /**
     * 承認担当者名
     * @type {string}
     * @memberof PostPlanChangeApprovalRequestApproveBody
     */
    approverName: string;
}

export function PostPlanChangeApprovalRequestApproveBodyFromJSON(json: any): PostPlanChangeApprovalRequestApproveBody {
    return PostPlanChangeApprovalRequestApproveBodyFromJSONTyped(json, false);
}

export function PostPlanChangeApprovalRequestApproveBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPlanChangeApprovalRequestApproveBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'approverName': json['approver_name'],
    };
}

export function PostPlanChangeApprovalRequestApproveBodyToJSON(value?: PostPlanChangeApprovalRequestApproveBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'approver_name': value.approverName,
    };
}

